import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  avatar: {
    fontSize: '32px !important'
  },
  cardIcon: {
    fontSize: 20
  },

  iconWrapper: {
    height: 40,
    width: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },

  card: {
    '.ant-card-body': {
      borderRadius: 12,
      padding: 6,
      background: token.lightGrey.lightGrey3
    }
  },
  textarea: {
    resize: `none !important` as 'none',
    height: '250px !important'
  },
  phoneIcon: {
    fontSize: 16
  },
  phoneWrapper: {
    borderRadius: token.borderRadiusSM,
    border: `1px solid ${token.colorBorder}`,
    paddingInline: 8
  },
  divider: {
    marginBlock: 24
  },
  fitContent: {
    width: 'fit-content'
  },
  smallTag: {
    padding: '1px 8px',
    lineHeight: '1'
  },
  warningIcon: {
    color: token.colorWarning,
    fontSize: 72
  },
  confirmModalContent: {
    paddingBlock: 32
  },
  successIcon: {
    color: token.colorSuccess
  },
  errorIcon: {
    color: token.colorError
  }
}))
